export default {
  config: {},
  deviceTypeLayout: null,
  gameState: {},
  gameLayout: 'Expanded',
  minBallSelection: 6,
  bingoColors: ['#dd1f1f', '#1cc51c', '#0087ff', '#a82def', '#844e14', '#efc82d', '#cb5b00', '#9a9a9a'],
  isAudioOn: false,
  minBingoNumber: 1,
  maxBingoNumber: 48,
  selectedBetNumbers: [],
  numbersBet: {},
  colorBet: {},
  selectedColor: {},
  selectedSpecialBet: {},
  firstBallColorBet: {},
  preballBet: {},
  selectedBet: {},
  showInfoModal: false,
  roundId: null,
  visualizationPlugin: {
    origin: {
      cf: {
        development: 'https://dev.draw-visualization.nsoft.app/luckysix',
        staging: 'https://staging.draw-visualization.nsoft.app/luckysix',
        production: 'https://draw-visualization.nsoft.app/luckysix',
      },
      netlify: {
        development: 'https://dev.draw-visualization.7platform.net/luckysix',
        staging: 'https://staging.draw-visualization.7platform.net/luckysix',
        production: 'https://draw-visualization.7platform.net/luckysix',
      },
    },
    type: 'v2', // move to games-static
    clientType: 'user',
    clientSubType: 'Player',
    encoding: {
      default: 'plaintext',
    },
  },
  oddsType: 'decimal', // move to games-static
  appMode: 'standalone', // move to games-static
  currentDrawnBall: null,
  gcmApi: {
    staging: ['https://gcm-1.staging.de.nsoftcdn.com:8443', 'https://gcm-2.staging.de.nsoftcdn.com:8443'],
    production: [
      'https://gcm-1.de.nsoftcdn.com:8443',
      'https://gcm-2.de.nsoftcdn.com:8443',
      'https://gcm-3.de.nsoftcdn.com:8443',
    ],
  },
  isBettingDisabled: false,
  stats: {
    drawnMostTimes: [
      {
        count: 100,
        ball: 1,
      },
      {
        count: 100,
        ball: 28,
      },
      {
        count: 100,
        ball: 22,
      },
      {
        count: 100,
        ball: 23,
      },
      {
        count: 100,
        ball: 24,
      },
    ],
    drawnLeastTimes: [
      {
        count: 0,
        ball: 48,
      },
      {
        count: 0,
        ball: 36,
      },
      {
        count: 0,
        ball: 37,
      },
      {
        count: 0,
        ball: 39,
      },
      {
        count: 0,
        ball: 40,
      },
    ],
    firstBallOddEven: {
      even: '',
      odd: '',
    },
    firstBallLowHigh: {
      low: '',
      high: '',
    },
    preballsMoreOddEven: {
      even: '',
      odd: '',
    },
    preballsSumLowHigh: {
      low: '',
      high: '',
    },
    firstBallColor: {
      red: 100,
      green: 0,
      blue: 0,
      purple: 0,
      brown: 0,
      yellow: 0,
      orange: 0,
      black: 0,
    },
  },
  resultsData: [],
  jackpotState: undefined,
  isonisList: ['MNE'],
  showLuckyLoserModal: false,
  showFreeBetModal: false,
  showFreeBetExpiredModal: false,
  isTerminal: false,
  countdownData: null,
  terminalUserData: null,
  ticketHistoryTerminal: [],
  ticketDetailsData: null,
  loaded: false,
  combinationsBase: 6, // TODO THIS IS USED INSIDE SDK, REFACTOR THAT FUNCTION AND REMOVE THIS AFTER
  terminalMouseCursorEnabled: true,
  activeComponent: null,
  ticketToRebet: null,
  userIsOperator: false,
  isVisualizationLoaded: false,
  thirdPartyInfo: {},
  printedTicketsByTicketCheck: [],
  ticketsPrintedByTicketUpdate: [],
  nextgenStandaloneIntegration: false,
  usePackageTranslations: true,
  frontIntegration: {},
  ticketsPaidInCurrentRound: false,
  animationStartEventSent: false,
  showOverlay: false,
  disableAllColorBetButton: false,
};
